import React from 'react';
import { TrendingUp, Users, Calculator } from 'lucide-react';
import CurrencyDisplay from '../CurrencyDisplay';

const RevenueStatsCards = ({ stats }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    <div className="bg-card border border-white/5 rounded-xl shadow-2xl p-4">
      <div className="flex items-center gap-2 mb-2">
        <TrendingUp className="w-5 h-5 text-primary" />
        <span className="text-sm text-muted-foreground">إجمالي الفترة</span>
      </div>
      <p className="text-2xl font-bold text-primary">
        <CurrencyDisplay amount={stats?.total_amount || 0} className="text-primary" />
      </p>
    </div>

    <div className="bg-card border border-white/5 rounded-xl shadow-2xl p-4">
      <div className="flex items-center gap-2 mb-2">
        <Users className="w-5 h-5 text-blue-500" />
        <span className="text-sm text-muted-foreground">عدد الزبائن</span>
      </div>
      <p className="text-2xl font-bold text-blue-500">{stats?.total_clients || 0}</p>
    </div>

    <div className="bg-card border border-white/5 rounded-xl shadow-2xl p-4">
      <div className="flex items-center gap-2 mb-2">
        <Calculator className="w-5 h-5 text-yellow-500" />
        <span className="text-sm text-muted-foreground">متوسط الزبون</span>
      </div>
      <p className="text-2xl font-bold text-yellow-500">
        <CurrencyDisplay
          amount={stats?.total_clients > 0 ? stats?.total_amount / stats?.total_clients : 0}
          className="text-yellow-500"
        />
      </p>
    </div>

    <div className="bg-card border border-white/5 rounded-xl shadow-2xl p-4">
      <div className="flex items-center gap-2 mb-2">
        <Calculator className="w-5 h-5 text-cyan-500" />
        <span className="text-sm text-muted-foreground">عدد العمليات</span>
      </div>
      <p className="text-2xl font-bold text-cyan-500">{stats?.revenues_count || 0}</p>
    </div>
  </div>
);

export default RevenueStatsCards;
